module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-Bold.269f0d72.woff";